import React from "react";
import Botdetail from "../../botDetailEndUser/index";
import { connect } from "react-redux";
import { useRouter } from 'next/router'

function index(props) {


  const router = useRouter()

  const [currentBot, setCurrentBot] = React.useState(null)





  React.useEffect(() => {
    setCurrentBot(props.currentBot)
  }, [props.currentBot])



  React.useEffect(() => {
    //console.log(router.query, "all kinda queries")
  }, [router.query])



  return (
    <div>
      <Botdetail globalData={props.globalData} data={props} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currentBot: state.storeBot.currentBot,
  };
};

export default connect(mapStateToProps, null)(index)
